import {Injectable} from '@angular/core';

@Injectable({providedIn: 'root'})
export class AppBreakpointsService {
	getBreakpointsMap(): {xl: number} {
		return {xl: 1200};
	}
}
